import { PdfFieldMapping } from '@cumu/shared';
import { target } from '@github/catalyst';
import { controller } from '../controller';
import { PDFViewerBase } from './pdf-viewer-base';
import { PDFViewerApplication } from './pdfjs';

@controller('pdf-viewer')
export class PdfViewerElement extends PDFViewerBase {
  @target declare valuesScript: HTMLScriptElement;
  preparedPromise = Promise.withResolvers<PDFViewerApplication>();

  onAnnotationFieldClick: undefined;
  onAnnotationFieldFocus: undefined;
  onCtrlS: undefined;
  onAnnotationLayerRendered: undefined;
  onAnnotationEditorUiManager: undefined;

  onAnnotationFieldChange() {
    this.dispatchEvent(
      new Event('pdf-viewer-field-changed', { bubbles: true })
    );
  }

  async onPdfLoaded(viewerApplication: PDFViewerApplication) {
    const values: Pick<PdfFieldMapping, 'name' | 'export_values' | 'value'>[] =
      JSON.parse(this.valuesScript.textContent!);
    const acroForm = await viewerApplication.pdfDocument.getFieldObjects();
    if (!acroForm) {
      console.warn('No acroForm found');
      this.preparedPromise.resolve(viewerApplication);
      return;
    }
    const fields = Object.values(acroForm).flat();
    for (const { name, export_values, value } of values) {
      const field = fields.find(
        field => field.name === name && field.exportValues === export_values
      );
      if (!field) {
        console.warn(
          `Field ${name} with export value ${export_values} not found`
        );
        continue;
      }
      if (field.value === value) {
        continue;
      }
      viewerApplication.pdfDocument.annotationStorage.setValue(field.id, {
        value
      });
    }
    this.preparedPromise.resolve(viewerApplication);
  }

  async save(): Promise<Uint8Array<ArrayBufferLike>> {
    // https://github.com/mozilla/pdf.js/blob/2e10ff6dd4a875b63743b4a764e7375f1bb94e1d/web/app.js#L1174
    // https://github.com/mozilla/pdf.js/blob/master/web/download_manager.js#L27
    const viewerApplication = await this.preparedPromise.promise;
    const downloadManager = viewerApplication.downloadManager;
    let data: Uint8Array<ArrayBufferLike>;
    viewerApplication.downloadManager = {
      download(d) {
        data = d;
      }
    };
    try {
      await viewerApplication.downloadOrSave();
    } finally {
      viewerApplication.downloadManager = downloadManager;
    }
    return Uint8Array.from(data!);
  }
}
